import React, { FC, useEffect, useState } from 'react';

import { AssignmentInput, MinimalUserProfileFragment, PublicUserProfileFragment } from 'api';
import { UserPicker } from 'components/Pickers';
import { useFormikContext } from 'formik';

interface IProps {
  users?: MinimalUserProfileFragment[];
}

const UsersSuggested: FC<IProps> = ({ users }) => {
  const { values, setFieldValue } = useFormikContext<AssignmentInput>();
  const { users_suggested_ids } = values;

  const [activeUsers, setActiveUsers] = useState(users || []);

  useEffect(() => {
    if (!users_suggested_ids?.length) {
      setActiveUsers([]);
    }
  }, [users_suggested_ids]);

  function handleChange(users: PublicUserProfileFragment[]) {
    // Manage locally to compensate for API
    setActiveUsers(users);
    setFieldValue(
      'users_suggested_ids',
      users.map(user => user.id)
    );
  }

  return (
    <UserPicker
      selectedUsers={activeUsers}
      onSelectedUsersChange={handleChange}
      excludeIds={activeUsers.map(user => user.id)}
    />
  );
};

export default UsersSuggested;
